/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectAll/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Checkbox from 'DesignSystem/Checkbox/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SelectAll({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration/Frequencies/Rulesets/Content/Ruleset/Frequencies/Frequency/Details/Content/AllowedDates/WeekDays/SelectAll"
  
}) {
let frequencyAllowedDatesValueData = fromData.useDataValue({ viewPath,
context: 'frequency',
path: 'allowed_dates',
})
let daysValueData = fromData.useDataFormat({ viewPath,
context: 'days',
format: fromHelpers.flatValues,
})
let aggregateData = fromAggregate.includesAll(frequencyAllowedDatesValueData, daysValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 data="frequency.allowed_dates"
 data="days"
 format="helpers.js flatValues"
 aggregate="/Data/aggregate.js includesAll"
 isSelected={aggregateData}
 onClick={onClick}
 marginLeft={dtSpaceXs}
 text="Select all"
/>
{children}
</React.Fragment>)
}